<div class="py-1">
  <py-badge [selectable]="true" [disabled]="disabled" [selected]="picked" (click)="select()" [large]="true" [tag]="true">{{
    label
  }}</py-badge>
</div>
